export default {
  phone: {
    numericOnly: true,
    blocks: [0, 1, 3, 3, 4],
    delimiters: ["+", " (", ") ", "-"],
  },
  postalCode: {
    uppercase: true,
    blocks: [3, 3],
  }
};
